import {
  resolveMasteryPage,
  applyMasteryPageToEntity
} from '../../domain/masteries/masteryPage.js';

/**
 * applyLobbyMasteries — apply Season 2 mastery page from lobby matchConfig.
 */
export function applyLobbyMasteries(matchConfig, playerEntity) {
  if (!matchConfig || !playerEntity || !matchConfig.masteryPage) return false;
  const page = resolveMasteryPage(matchConfig.masteryPage);
  if (!page) return false;
  return applyMasteryPageToEntity(playerEntity, page).ok;
}
